import { GENERAL_TEXT } from '@/texts/catalog/general';

export const TAX_MODE_OPTIONS = Object.freeze([
  {
    value: 'individual',
    label: GENERAL_TEXT.financial.taxes.mode.individual,
  },
  {
    value: 'group',
    label: GENERAL_TEXT.financial.taxes.mode.group,
  },
]);
